function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { usePrefixCls } from '@byte-design/config';
import { classnames } from '@bydesign-ui/utils';
import { usePrevProp, useSingleton } from '@bydesign-ui/hooks';
import React, { useCallback, useEffect, useLayoutEffect } from 'react';
var columnChildren = Array.from('012345678901234567890123456789').map(function (char, index) {
  return React.createElement("p", {
    key: index
  }, char);
});
var Effect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
export var AnimatedNumber = function AnimatedNumber(_ref) {
  var className = _ref.className,
      value = _ref.value,
      restProps = _objectWithoutProperties(_ref, ["className", "value"]);

  var cls = usePrefixCls('animated-number');
  var absValue = Math.trunc(Math.abs(value));
  var columnCount = absValue ? Math.trunc(Math.log10(absValue)) + 1 : 1;
  var columns = Array.from({
    length: columnCount
  }).map(function (_, index) {
    return React.createElement(AnimatedNumberBit, {
      absValue: absValue,
      index: index,
      key: index
    });
  });
  return React.createElement("div", Object.assign({}, restProps, {
    className: classnames(cls, className)
  }), Math.trunc(value) < 0 && '-', columns.reverse());
};

var AnimatedNumberBit = function AnimatedNumberBit(_ref2) {
  var absValue = _ref2.absValue,
      index = _ref2.index;
  var offset = Math.trunc(absValue / Math.pow(10, index) % 10) * 100;
  var prevOffset = usePrevProp(offset)[1];
  var prevAbsValue = usePrevProp(absValue)[1];
  var className = usePrefixCls('animated-number-bit');
  var ref = useSingleton(function () {
    return {
      current: null,
      offset: offset
    };
  });
  var isReverseAnimation = offset < prevOffset !== absValue < prevAbsValue && offset > prevOffset !== absValue > prevAbsValue;
  var resetStyle = useCallback(function () {
    var element = ref.current;
    var needResetImmediately = ref.needResetImmediately;

    if (element && (ref.needReset || ref.needResetImmediately)) {
      ref.needReset = false;
      ref.needResetImmediately = false;
      var final = "translate3d(0,-".concat(ref.offset + 1000, "%,0)");
      var trans = "translate3d(0,-".concat(ref.offset + (ref.lessThanPrev ? 1100 : 900), "%,0)");
      element.style.setProperty('transition-duration', '0s');

      if (needResetImmediately) {
        element.style.setProperty('transform', trans);
        setTimeout(function () {
          element.style.removeProperty('transition-duration');
          element.style.setProperty('transform', final);
        }, 0);
      } else {
        element.style.setProperty('transform', final);
        setTimeout(function () {
          return element.style.removeProperty('transition-duration');
        }, 0);
      }
    }
  }, [ref]);
  ref.offset = offset;
  ref.lessThanPrev = offset < prevOffset;
  ref.needResetImmediately = ref.needReset;
  ref.needReset = isReverseAnimation || ref.needReset;
  Effect(function () {
    if (ref.needResetImmediately) {
      resetStyle();
    }
  });
  return React.createElement("span", {
    className: className,
    ref: ref,
    onTransitionEnd: resetStyle,
    style: {
      transform: isReverseAnimation ? "translate3d(0,-".concat(offset + (offset < prevOffset ? 2000 : 0), "%,0)") : "translate3d(0,-".concat(offset + 1000, "%,0)")
    }
  }, columnChildren);
};